import styled from 'styled-components';

import InfoIcon from '@mui/icons-material/Info';

export const HelpIcon = styled(InfoIcon)`
  font-size: 14px;
  margin-left: 6px;
  color: ${({ theme }) => theme.palette.text.secondary};
  vertical-align: middle;
  cursor: help;
`;
